import React from "react";
import D01 from "../Video/D01";
export default function VideoMain({ data }) {
  return (
    <div>
      {/* {JSON.stringify(data)} */}
      {data?.advanceData?.design === 'D01_L01' ? (
        <D01 videoItem={data}></D01>
      ) : (
        <D01 videoItem={data}></D01>
      )}
    </div>
  );
}
